import React, { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton, { Theme } from '@atlaskit/button/custom-theme-button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';

import { SortButtonTheme } from './sort-button-styles';
import messages from './sort-button.i18n';

type Props = {
  onClick: () => void;
  isAscending?: boolean;
};

export default class SortButton extends PureComponent<Props> {
  render() {
    return (
      <Theme.Provider value={SortButtonTheme}>
        <CustomThemeButton
          appearance="subtle-link"
          spacing="none"
          iconAfter={
            this.props.isAscending ? (
              <ChevronUpIcon label="" />
            ) : (
              <ChevronDownIcon label="" />
            )
          }
          onClick={this.props.onClick}
        >
          <FormattedMessage {...messages.updated} />
        </CustomThemeButton>
      </Theme.Provider>
    );
  }
}
